export default __webpack_public_path__ + "static/media/logo-gie.43dde6c7.svg";